import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a400d7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-lg border border-gray-200 shadow-sm" }
const _hoisted_2 = { class: "flex items-start gap-2 min-w-0 flex-1" }
const _hoisted_3 = {
  class: "w-5 h-5 text-primary30 shrink-0 mt-0.5",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_4 = ["d"]
const _hoisted_5 = { class: "min-w-0 flex-1" }
const _hoisted_6 = { class: "text-sm font-semibold text-gray-700 leading-tight" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-gray-400"
}
const _hoisted_8 = {
  key: 1,
  class: "text-[10px] text-gray-400 leading-tight mt-1"
}
const _hoisted_9 = {
  key: 2,
  class: "text-[11px] text-gray-500 leading-tight mt-0.5"
}
const _hoisted_10 = ["d"]
const _hoisted_11 = {
  key: 0,
  class: "px-3 pb-3 border-t border-gray-100 pt-2"
}
const _hoisted_12 = {
  key: 0,
  class: "text-xs text-gray-500 mb-2"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Escalado por:", -1))
const _hoisted_14 = { class: "text-xs text-gray-700 mb-2 leading-relaxed" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "font-semibold" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "font-semibold" }
const _hoisted_19 = {
  key: 2,
  class: "text-[10px] text-gray-400"
}
const _hoisted_20 = { class: "grid grid-cols-2 gap-x-4 gap-y-1.5 text-xs" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-400" }, "Formação", -1))
const _hoisted_22 = { class: "text-gray-700" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-400" }, "Tipo", -1))
const _hoisted_24 = { class: "text-gray-700" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-400" }, "Posição", -1))
const _hoisted_26 = { class: "text-gray-700" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-400" }, "Turno", -1))
const _hoisted_28 = { class: "text-gray-700" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-400" }, "Time", -1))
const _hoisted_30 = { class: "text-gray-700" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-400" }, "Valor", -1))
const _hoisted_32 = { class: "text-gray-700" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-400" }, "Repasse", -1))
const _hoisted_34 = { class: "text-gray-700" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-400" }, "Proporcionalidade", -1))
const _hoisted_36 = { class: "text-gray-700" }

import { ref } from 'vue'
import { mdiAccountCircle, mdiChevronDown } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'StationContextCard',
  props: {
    doctorName: {},
    doctorCrm: {},
    scheduleName: {},
    positionName: {},
    shiftName: {},
    team: {},
    timeRange: {},
    dutyType: {},
    value: {},
    formation: {},
    repassMode: {},
    proportionalityRule: {},
    breadcrumb: {},
    allocatedBy: {},
    startDetail: {},
    endDetail: {},
    timezone: {},
    defaultExpanded: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const isExpanded = ref(props.defaultExpanded !== false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isExpanded.value = !isExpanded.value)),
      class: "w-full flex items-center justify-between p-3 text-left gap-2"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock("svg", _hoisted_3, [
          _createElementVNode("path", { d: _unref(mdiAccountCircle) }, null, 8, _hoisted_4)
        ])),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.doctorName), 1),
          (_ctx.doctorCrm)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, "CRM " + _toDisplayString(_ctx.doctorCrm), 1))
            : _createCommentVNode("", true),
          (_ctx.breadcrumb)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.breadcrumb), 1))
            : _createCommentVNode("", true),
          (_ctx.startDetail)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.startDetail), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      (_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(["w-4 h-4 text-gray-400 shrink-0 transition-transform duration-200", { 'rotate-180': isExpanded.value }]),
        fill: "currentColor",
        viewBox: "0 0 24 24"
      }, [
        _createElementVNode("path", { d: _unref(mdiChevronDown) }, null, 8, _hoisted_10)
      ], 2))
    ]),
    _createVNode(_Transition, { name: "expand" }, {
      default: _withCtx(() => [
        (isExpanded.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_ctx.allocatedBy)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.allocatedBy), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                (_ctx.startDetail)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                      _createTextVNode(" De "),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.startDetail), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.endDetail)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                      _createTextVNode(" Até "),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.endDetail), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.timezone)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Horário de " + _toDisplayString(_ctx.timezone), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", null, [
                  _hoisted_21,
                  _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.formation || 'N/A'), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_23,
                  _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.dutyType || 'N/A'), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_25,
                  _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.positionName || 'N/A'), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_27,
                  _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.shiftName || 'N/A'), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_29,
                  _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.team || 'N/A'), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_31,
                  _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.value || 'N/A'), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_33,
                  _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.repassMode || 'N/A'), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_35,
                  _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.proportionalityRule || 'N/A'), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})